<template>
  <div class="home-page-container" ref="container">
    <p class="title-wrapper">
      <span class="home-title"></span>
      <span class="title">Economic Data of Xinhua Silk Road</span>
    </p>

    <div class="card-wrapper">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-card class="box-card1">
            <number-title :value="companyTotal"></number-title>
            <div class="tag-wrapper">
              <span class="tag-title"> Total number of companies</span>
              <span class="tag-img compang-tag"></span>
            </div>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card class="box-card2">
            <number-title :value="TransacTotal"></number-title>
            <div class="tag-wrapper">
              <span class="tag-title">Total M&A transactions </span>
              <span class="tag-img transcation-tag"></span>
            </div>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card class="box-card3">
            <number-title :value="IndicatTotal"></number-title>
            <div class="tag-wrapper">
              <span class="tag-title">Total number of indicators</span>
              <span class="tag-img industry-tag"></span>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>

    <div class="tab_">
      <el-tabs v-model="activeName" @tab-click="tabClick">
        <el-tab-pane name="first">
          <span slot="label">
            <span class="maker"></span> Company
          </span>
          <company :chartHeight="chartHeight" v-if="activedList.includes('first')"></company>
        </el-tab-pane>
        <el-tab-pane name="second">
          <span slot="label">
            <span class="maker"></span> Industry
          </span>
          <industry :chartHeight="chartHeight" v-if="activedList.includes('second')"></industry>
        </el-tab-pane>
        <el-tab-pane name="third">
          <span slot="label">
            <span class="maker"></span> Macro Data
          </span>
          <macro :chartHeight="chartHeight" v-if="activedList.includes('third')"></macro>
        </el-tab-pane>
        <el-tab-pane name="fourth">
          <span slot="label">
            <span class="maker"></span> M&A Transactions
          </span>
          <transcation :chartHeight="chartHeight" v-if="activedList.includes('fourth')"></transcation>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import NumberTitle from "./number";
import Company from "./company";
import Industry from "./industry";
import Macro from "./macro";
import Transcation from "./transcation";

import { getTotalData } from "common/js/http/v2Api";
export default {
  components: {
    NumberTitle,
    Company,
    Industry,
    Macro,
    Transcation
  },

  data() {
    return {
      companyTotal: 0,
      TransacTotal: 0,
      IndicatTotal: 0,

      //tab
      activeName: "first",
      activedList: ["first"],
      chartHeight: 0
    };
  },

  created() {
    this.getStatisicalData();
  },

  mounted() {
    this.getTabContentHeight();
  },

  methods: {
    getTabContentHeight() {
      const height = this.$refs.container.clientHeight;
      //487
      this.chartHeight = height - 480;
      // console.log("getTabContentHeight -> height", height);
    },

    tabClick() {
      if (!this.activedList.includes(this.activeName)) {
        this.activedList.push(this.activeName);
      }
    },

    async getStatisicalData() {
      const {result} = await getTotalData();
      this.companyTotal = result.companyCount;
      this.TransacTotal = result.maTransactionCount;
      this.IndicatTotal = result.indictorCount;
      // 
    }
  }
};
</script>


<style scoped>
.home-page-container {
  height: 100%;
}
.title-wrapper {
  padding: 32px 15px;
  font-size: 18px;
  color: #333333;
  letter-spacing: 0;
  font-weight: 600;
}
.card-wrapper >>> .el-card__body {
  height: 120px !important;
}
.tag-wrapper {
  padding-top: 15px;
}
.tag-title {
  font-size: 14px;
  color: #4e5671;
  line-height: 22px;
}
.card-wrapper {
  padding: 0px 15px;
}
.box-card1 {
  background: #e3e3fb;
}
.box-card2 {
  background: #2514030f;
}
.box-card3 {
  background: #fbf9e3;
}

.tab_ {
  padding-top: 50px;
}

.tab_ >>> .el-tabs__nav {
  width: 100%;
}
.tab_ >>> .el-tabs__item {
  width: 25%;
}
.tab_ >>> .el-tabs__content {
  padding: 20px 15px 0px 15px !important;
}
</style>